import { Button, useNavigate } from "@for-it/web-lib";
import { Routes } from "../routes.tsx";

export default function NotFoundPageAdmin() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col items-center justify-center p-6">
            <div className="max-w-md w-full text-center bg-white rounded-2xl shadow-xl p-6 mx-auto">
                <div className="mb-6">
                    <div className="w-24 h-24 mx-auto bg-red-100 rounded-full flex items-center justify-center">
                        <svg
                            className="w-12 h-12 text-red-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z"
                            />
                        </svg>
                    </div>
                </div>
                <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
                <h2 className="text-2xl font-semibold text-gray-700 mb-2">
                    Página No Encontrada
                </h2>
                <p className="text-gray-500 mb-4 leading-relaxed">
                    Lo sentimos, la página que estás buscando no existe o ha
                    sido movida. Por favor, verifica la URL o regresa al inicio
                    de sesión.
                </p>
                <Button
                    onClick={() => navigate.toRoute(Routes.LOGIN.path())}
                    className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-md hover:shadow-lg"
                >
                    Ir al login
                </Button>
            </div>
        </div>
    );
}
